import { SWRConfiguration } from "swr";
import { ApiResponse, ServerResponse } from "./axiosConfig";
import { useSwr } from "./axiosHVS";
import { HvsEntity } from "./hvsBase";

export type EntityType = HvsEntity;

export const useEntityType = (
  id: string,
  config?: SWRConfiguration
): ServerResponse<ApiResponse<EntityType>> => {
  const baseCameraKey = `entitytypes/${id}`;
  return useSwr<ApiResponse<EntityType>>(`${baseCameraKey}`, config);
};

export const useEntityTypeCamera = (
  config?: SWRConfiguration
): ServerResponse<ApiResponse<EntityType>> => {
  const baseCameraKey = `systemtypes/camera`;
  return useSwr<ApiResponse<EntityType>>(`${baseCameraKey}`, config);
};

export const useEntityTypeVms = (
  config?: SWRConfiguration
): ServerResponse<ApiResponse<EntityType>> => {
  const baseCameraKey = `systemtypes/vms`;
  return useSwr<ApiResponse<EntityType>>(`${baseCameraKey}`, config);
};
